var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17.6001H29.9839V3H7V17.6001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38269 17.2195H29.6007V15.2275H7.38269V17.2195Z",
    fill: "#F7B600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38269 5.37499H29.6007V3.38306H7.38269V5.37499Z",
    fill: "#1A1F71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3001 7.56951L17.129 13.0447H15.7125L16.8837 7.56951H18.3001ZM24.2593 11.105L25.005 9.04877L25.434 11.105H24.2593ZM25.8404 13.0447H27.1502L26.0059 7.56951H24.7977C24.5254 7.56951 24.2959 7.72741 24.1943 7.97087L22.0688 13.0447H23.5564L23.8518 12.227H25.6688L25.8404 13.0447ZM22.1426 11.2571C22.1489 9.81224 20.1452 9.73212 20.1585 9.08655C20.1629 8.89033 20.35 8.68135 20.7591 8.62793C20.962 8.60176 21.5216 8.58069 22.1561 8.87299L22.4042 7.71145C22.0634 7.58823 21.6249 7.46948 21.0794 7.46948C19.6791 7.46948 18.6939 8.21327 18.6861 9.27925C18.6771 10.0675 19.3897 10.507 19.9255 10.7695C20.478 11.0378 20.6631 11.21 20.6604 11.4497C20.6566 11.8171 20.2198 11.9796 19.8133 11.9858C19.1006 11.9969 18.6878 11.7932 18.3585 11.6398L18.1015 12.8401C18.4329 12.9918 19.0437 13.1238 19.6762 13.1307C21.1648 13.1307 22.1382 12.3955 22.1426 11.2571ZM16.2762 7.56951L13.9811 13.0447H12.4839L11.3544 8.67507C11.286 8.4064 11.2263 8.30765 11.0181 8.19411C10.6775 8.00907 10.1151 7.83605 9.62073 7.72837L9.65414 7.56951H12.0645C12.3715 7.56951 12.6477 7.77381 12.7179 8.1274L13.3145 11.296L14.7881 7.56951H16.2762Z",
    fill: "#1A1F71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    stroke: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/payment-visa.be0e636aef31f5104e6a8a3a2da82656.svg";
export { ForwardRef as ReactComponent };